module.exports = __webpack_public_path__ + "static/cleliaWelcome-abd943086cf860b8c3647654809aa338.jpg";